import { RootState } from "redux/rootReducer";

export const selectIsDownloadingFullStressPDF = (state: RootState) =>
  state.fullStressPdfDownload.loading;
export const fullStressPdfDownloadErrorMessage = (state: RootState) =>
  state.fullStressPdfDownload.error;
export const fullStressPdfDownloadSuccessResponse = (state: RootState) =>
  state.fullStressPdfDownload.fullStressPdfDownloadResponse;
